import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { StreamFlowPacer } from '@atlassian/editor-ai-common/api/stream-flow-pacer';
import type { Ramp } from '@atlassian/editor-ai-common/api/stream-flow-pacer';

function isNumber(value: unknown): value is number {
	return typeof value === 'number';
}

function isRamp(value: unknown): value is Ramp {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const v = value as Record<string, unknown>;
	return (
		isNumber(v.initialDelaySec) &&
		isNumber(v.stepDelaySec) &&
		isNumber(v.flushDelaySec) &&
		isNumber(v.growthFactor)
	);
}

function getExperimentValue(key: string, defaultValue: number): number {
	return FeatureGates.getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
		typeGuard: isNumber,
	});
}

export function createStreamFlowPacer(enabled?: boolean): StreamFlowPacer | null {
	if (enabled === false) {
		return null;
	}

	const backlogRampThreshold = getExperimentValue('backlogRampThreshold', 100);
	const initialCharsPerTick = getExperimentValue('initialCharsPerTick', 8);
	const maxCharsPerTick = getExperimentValue('maxCharsPerTick', 1000);
	const tickMs = getExperimentValue('tickMs', 41);

	const ramp = FeatureGates.getExperimentValue(
		'platform-editor-ai-streaming-speed',
		'ramp',
		{
			initialDelaySec: 6,
			stepDelaySec: 3,
			flushDelaySec: 0.5,
			growthFactor: 1.5,
		},
		{ typeGuard: isRamp },
	);

	// These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
	return new StreamFlowPacer({
		backlogRampThreshold,
		initialCharsPerTick,
		maxCharsPerTick,
		ramp,
		tickMs,
	});
}
